import { registerPlugin } from '@capacitor/core';

import type { OneSignalPlugin } from './definitions';

const OneSignal = registerPlugin<OneSignalPlugin>('OneSignal', {
    web: () => import('./web').then(module => new module.OneSignalSPMWeb())
});

export * from './definitions';
export { OneSignal };
